import PlanRoutes from './plan.routes';
import ActualRoutes from './actual.routes';

export default [
  ...PlanRoutes,
  ...ActualRoutes,
]
